import { Component } from 'react';
import Message from '../../Message';
import Loading from '../../../components/Loading';
import EditKeywordModal from './modal/editKeyword';
import { disableKeyword, enableKeyword } from './query';
import { withTranslation } from 'react-i18next';
import EditProject from './modal/editProject';

class Actions extends Component {
    constructor(props) {
        super();

        this.onDisableKeyword = this.onDisableKeyword.bind(this);
        this.deleteMessage = this.deleteMessage.bind(this);
        this.onOpenEdit = this.onOpenEdit.bind(this);
        this.onCloseEdit = this.onCloseEdit.bind(this);

        this.state = {
            status: props.status === 'active',
            isOpenEdit: false,
        };
    }

    onOpenEdit() {
        this.setState({
            isOpenEdit: true,
        });
    }
    onCloseEdit() {
        this.setState({
            isOpenEdit: false,
        });
    }

    async onDisableKeyword() {
        try {
            this.setState({ loading: true });

            if (this.state.status) {
                await disableKeyword(this.props.item.id);
            } else {
                await enableKeyword(this.props.item.id);
            }
            this.setState({
                status: !this.state.status,
                loading: false,
            });
            // this.props.getKeywords();
        } catch (err) {
            this.setState({
                loading: false,
            });
            console.log(err);
        }
    }

    deleteMessage() {
        this.setState({ message: '' });
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <div className="ai-tracking-actions d-flex gap-8">
                    {this.state.loading ? (
                        <div className="px-5 d-flex align-items-center">
                            <Loading onlyPreloader />
                        </div>
                    ) : (
                        <button
                            className="ignor-icon-btn"
                            onClick={this.onDisableKeyword}
                            title={
                                this.state.status
                                    ? t('ai_tracking.keyword_manager.edit_keyword.disable_title')
                                    : t('ai_tracking.keyword_manager.edit_keyword.enable_title')
                            }
                        >
                            <span
                                className={`switch-button ${
                                    this.state.status ? 'active' : 'not-active'
                                }`}
                            >
                                <span className="switch-circle" />
                            </span>
                        </button>
                    )}
                    <div className="ai-tracking-edit-btn">
                        <button className="table-action-main-btn" onClick={this.onOpenEdit}>
                            <i className="icon-pencil"></i>
                        </button>
                    </div>
                </div>

                {this.state.message && (
                    <div className="messages">
                        <Message
                            message_tags={'error'}
                            message={this.state.message}
                            deleteMessage={this.deleteMessage}
                        />
                    </div>
                )}
                <EditKeywordModal
                    isOpen={this.state.isOpenEdit}
                    onClose={this.onCloseEdit}
                    item={this.props.item}
                    getKeywords={this.props.getKeywords}
                />
            </>
        );
    }
}

export default withTranslation()(Actions);
